// Share activity only among tabs using the same authenticated session. These
// timestamps are convenience state; server-side trust and expiry are authoritative.
export function monitorSessionActivity(options: { target: Window; activityKey: string; timeoutMs: number; onIdle: () => Promise<unknown> }) {
  const { target, timeoutMs, onIdle } = options;
  const storageKey = `yodl:activity:${options.activityKey}`;
  let lastActivity = Date.now();
  let lastStored = 0;
  let pending = false;
  const record = () => {
    lastActivity = Date.now();
    if (lastActivity - lastStored < 5000) return;
    try { target.localStorage.setItem(storageKey, String(lastActivity)); lastStored = lastActivity; } catch { /* Storage may be disabled. */ }
  };
  const onStorage = (event: StorageEvent) => {
    if (event.key !== storageKey) return;
    const time = Number(event.newValue);
    if (Number.isFinite(time) && time <= Date.now()) lastActivity = Math.max(lastActivity, time);
  };
  const check = () => {
    if (pending || target.document.visibilityState === "hidden") return;
    try {
      const time = Number(target.localStorage.getItem(storageKey));
      if (Number.isFinite(time) && time <= Date.now()) lastActivity = Math.max(lastActivity, time);
    } catch { /* Fall back to this tab's activity. */ }
    if (Date.now() - lastActivity < timeoutMs) return;
    pending = true;
    void onIdle().catch(() => { pending = false; });
  };
  const events = ["pointerdown", "pointermove", "keydown", "touchstart", "wheel", "scroll"] as const;
  for (const event of events) target.addEventListener(event, record, { passive: true, capture: true });
  target.addEventListener("storage", onStorage);
  record();
  const timer = target.setInterval(check, 15_000);
  return () => {
    target.clearInterval(timer);
    for (const event of events) target.removeEventListener(event, record, { capture: true });
    target.removeEventListener("storage", onStorage);
  };
}
